<div class="splash-overlay">
  <div class="splash-card">

    <!-- Animated background blobs -->
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>

    <!-- Icon -->
    <div class="splash-icon-ring">
      <mat-icon class="splash-icon">person_outline</mat-icon>
    </div>

    <!-- Headline -->
    <h1 class="splash-title">Complete your profile</h1>
    <p class="splash-subtitle">
      Your profile is not complete yet.<br>
      Fill in the missing sections to get started.
    </p>

    <!-- Steps -->
    <div class="splash-steps">
      @for (step of steps; track step; let i = $index) {
        <div class="splash-step" [style.animation-delay]="(i * 80) + 'ms'">
          <div class="step-number">{{ i + 1 }}</div>
          <span class="step-label">{{ step.label }}</span>
        </div>
      }
    </div>

    <!-- CTA -->
    <button class="splash-cta" (click)="onLetsGo()" data-testid="complete-profile-lets-go" data-test="complete-profile-lets-go">
      Let's go &nbsp; →
    </button>

    <p class="splash-note">You can skip steps and come back later</p>

  </div>
</div>
